import BrButton from '@govbr/react-components/lib/BrButton';
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import iconeIdPositiva from '../../assets/img/icone-id-positiva.svg';
import iconeMulherSentada from '../../assets/img/icone-splash-mulher-sentada.svg';
import logoCadunicoVerdeAmarelo from '../../assets/img/logo-cadunico-verde-amarelo.svg';
import logoGovbr from '../../assets/img/logo-govbr.svg';
import logoMinisterioDesenvolvimento from '../../assets/img/ministerio_desenvolvimento.png';
import configuration from '../../envConfig';
import styles from './Informativo.module.css';

const Informativo: React.FC = () => {
  const history = useHistory();

  const [page, setPage] = useState(1);

  useEffect(() => {
    if (localStorage.getItem('cadunico/splash-visualizado') === 'true') {
      history.replace('/home');
    }
    return () => {
      localStorage.setItem('cadunico/splash-visualizado', 'true');
    }
  }, [history]);

  const pagina1 = (
    <div className={styles.container} onClick={() => setPage(2)}>

    <img className={styles.logoCadunico} src={logoCadunicoVerdeAmarelo} alt="Logo Cadastro Unico" />
      <span className={styles.textoInicial}>Toque para iniciar</span>
      <img className={styles.logoCidadania} src={logoMinisterioDesenvolvimento} alt="Logo Ministério do Desenvolvimento e Assistência Social, Família e Combate à Fome" />
      {configuration.versao && (
        <div className={styles.versao}>
          VERSÃO {configuration.versao}
        </div>
      )}
    </div>
  );

  const pagina2 = (
    <div className={styles.container}>
      <div className={styles.textoWrapper}>
        <img className={styles.logoCadunicoPagina2} src={logoCadunicoVerdeAmarelo} alt="Logo Cadastro Unico" />
        <div className={styles.texto}>
         Esse é um novo canal de atendimento do Cadastro Único para Programas Sociais!
        </div>
      </div>
      <img className={styles.iconeMulherSentada} src={iconeMulherSentada} alt="Imagem Mulher Sentada com Celular" />
      <div className={styles.footer}>
        <div className={styles.buttonRegion}>
          <BrButton className={`${styles.botao} ${styles.secundario}`} onClick={() => setPage(1)}>
            <i className="fa fa-chevron-left"></i>
          </BrButton>
          <div className={styles.bulletPointWrapper}>
            <div onClick={() => setPage(1)} className={styles.bulletPoint}></div>
            <div onClick={() => setPage(2)} className={`${styles.bulletPoint} ${styles.selecionado}`}></div>
            <div onClick={() => setPage(3)} className={styles.bulletPoint}></div>
          </div>
          <BrButton className={styles.botao} onClick={() => setPage(3)}>
            <i className="fa fa-chevron-right"></i>
          </BrButton>
        </div>
        <Link to="/home">
          <div className={styles.skipTutorial}>
            Pular tutorial
          </div>
        </Link>
      </div>
    </div>
  );

  const pagina3 = (
    <div className={styles.container}>
      <div className={styles.textoWrapper}>
        <div className={styles.titulo}>
          Como acessar?
        </div>
        <div className={styles.infoRowsWrapper}>
          <div className={styles.infoRow}>
            <div className={styles.infoImg}>
              <img src={logoGovbr} alt="Logo gov.br"/>
            </div>
            <div className={styles.infoTextWrapper}>
              <div className={styles.infoNumber}>1.</div>
              <div className={styles.infoText}>
                Com o gov.br para ter acesso completo ao seu cadastro e serviços do aplicativo
              </div>
            </div>
          </div>
          <div className={styles.infoRow}>
            <div className={styles.infoImg}>
              <img src={iconeIdPositiva} alt="Ícone identificação positiva" />
            </div>
            <div className={styles.infoTextWrapper}>
              <div className={styles.infoNumber}>2.</div>
              <div className={styles.infoText}>
                Com seus dados pessoais para consulta simplificada do seu cadastro
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.buttonRegion}>
          <BrButton className={`${styles.botao} ${styles.secundario}`} onClick={() => setPage(2)}>
            <i className="fa fa-chevron-left"></i>
          </BrButton>
          <div className={styles.bulletPointWrapper}>
            <div onClick={() => setPage(1)} className={styles.bulletPoint}></div>
            <div onClick={() => setPage(2)} className={styles.bulletPoint}></div>
            <div onClick={() => setPage(3)} className={`${styles.bulletPoint} ${styles.selecionado}`}></div>
          </div>
          <Link to="/home">
            <BrButton className={styles.botao} onClick={() => setPage(2)}>
              <i className="fa fa-chevron-right"></i>
            </BrButton>
          </Link>
        </div>
        <Link to="/home">
          <div className={styles.skipTutorial}>
            Pular tutorial
          </div>
        </Link>
      </div>
    </div>
  );

  return (
    <>
      {page === 1 && pagina1}
      {page === 2 && pagina2}
      {page === 3 && pagina3}
    </>
  );
}

export default Informativo;
